module.exports = __webpack_public_path__ + "img/图片 1(1).ab36924b.png";